import React, { useEffect, useState } from 'react';
import { Box, Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import * as reservationsActions from 'services/api/reservations';
import { buildUrl } from 'utils/utils';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import i18n from 'i18n-js';

const PendingReservationsBanner = () => {
  const isPendingFeaturesEnabled = useFeatureIsOn('reservations_pending_behaviors');
  const [hasPending, setHasPending] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkPendingReservations = async () => {
      try {
        const response = await reservationsActions.fetchReservations({
          page: 1,
          limit: 10,
          statuses: ['PENDING'],
        });

        if (response.ok && response.data && response.data.length > 0) {
          setHasPending(true);
        }
      } catch (error) {
        console.error('Error fetching pending reservations:', error);
      } finally {
        setLoading(false);
      }
    };

    checkPendingReservations();
  }, []);

  if (!isPendingFeaturesEnabled || loading || !hasPending) {
    return null;
  }

  return (
    <Box
      sx={{
        backgroundColor: '#F7D7A0',
        height: '46px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingX: 3,
        borderRadius: '8px 8px 0 0',
        marginBottom: '-8px', // To overlap slightly or align with the card below if needed
        position: 'relative',
        zIndex: 1,
      }}
    >
      <Typography
        sx={{
          fontSize: '14px',
          fontWeight: 500,
          color: '#2C2C2E',
        }}
      >
        {i18n.t('dashboard.pending_reservations_banner_text')}
      </Typography>
      <Link
        component={RouterLink}
        to={buildUrl('/reservations?statuses=PENDING')}
        sx={{
          fontSize: '14px',
          fontWeight: 'bold',
          color: '#387FF7',
          textDecoration: 'none',
          '&:hover': {
            textDecoration: 'underline',
          },
        }}
      >
        {i18n.t('dashboard.go_to_reservations')}
      </Link>
    </Box>
  );
};

export default PendingReservationsBanner;
